import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ParticipantMessages } from './-components/participant-messages';

const messagesSearchSchema = z.object({
  /** Uid of the open conversation — in the URL so mobile back navigation and
   * deep links land on the right thread. */
  conversation: z.string().optional(),
  /**
   * Legacy deep-link params — the legacy messages page's names, still emitted
   * by legacy dashboard links and notification emails. `conversationUid` is
   * an alias for `conversation`; `surveyResponseId`/`projectId` resolve to an
   * existing conversation or open compose preselected with the project.
   */
  conversationUid: z.string().optional(),
  surveyResponseId: z.string().optional(),
  projectId: z.string().optional(),
});

export const Route = createFileRoute('/participants/_authenticated/messages/')({
  validateSearch: messagesSearchSchema,
  component: MessagesPage,
});

function MessagesPage() {
  const { user, env } = Route.useRouteContext();
  const { conversation, conversationUid, surveyResponseId, projectId } =
    Route.useSearch();
  const navigate = Route.useNavigate();

  const selectConversation = (selected: string | null) => {
    void navigate({
      search: { conversation: selected ?? undefined },
    });
  };

  return (
    <ParticipantMessages
      userId={user.id}
      pusherAppKey={env.PUSHER_APP_KEY}
      // The legacy `conversationUid` param is an alias for `conversation`.
      selectedConversationUid={conversation ?? conversationUid ?? null}
      onSelectConversation={selectConversation}
      deepLinkSurveyResponseId={surveyResponseId}
      deepLinkProjectId={projectId}
    />
  );
}
